// ======================================================================
// File Name       : user
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as UserActionTypes from '../../constants/actionTypes/user';
import { UPDATE_AUTH_USER_INFO } from '../../constants/ActionTypes';

export function receiveUserList({ recordNum, userList }) {
  return {
    type: UserActionTypes.USER_RECEIVE_USER_LIST,
    userList,
    recordNum,
  };
}

export function updateUserInfo(newUserInfo) {
  return {
    type: UPDATE_AUTH_USER_INFO,
    newUserInfo,
  };
}

export function storeUserList(userSearchResult, groupRelationList, groupInfo) {
  return {
    type: UserActionTypes.STORE_USER_LIST_ON_DIALOG,
    userSearchResult,
    groupRelationList,
    groupInfo,
  };
}

export function storeMyUserInfo(userInfo) {
  return {
    type: UserActionTypes.STORE_MY_USER_INFO,
    userInfo,
  };
}

export function getAuthorityUserLoging(data) {
  return {
    type: UserActionTypes.AUTHORITY_USER_LOGING,
    data,
  };
}

export function getUserGroupRelationUserLoging(data) {
  return {
    type: UserActionTypes.USER_GROUP_RELATION_USER_LOGING,
    data,
  };
}

export function getGroupCourseRelation(data) {
  return {
    type: UserActionTypes.GET_GROUP_COURSE_RELATION,
    data,
  };
}

export function getManagementUserInfo(data) {
  return {
    type: UserActionTypes.GET_MANAGEMENT_USER_INFO,
    data,
  };
}